/* Smart Station redesign: grade pills + header search suggestions + filter labels/visibility + sold-out last
   + collection links open "in stock only". */
(function(){
  var RE = /^\s*\[([^\]]{1,24})\]\s*/;

  /* The product-tag filter is added in Search & Discovery with its default label "More filters".
     In this theme it is the device-model filter, so show it as "Model": in the filter group headings
     (desktop, horizontal and mobile drawer) and in the active-filter chips ("Model: iPhone 13"). */
  var TAG_FILTER_FROM = 'More filters';
  var TAG_FILTER_TO = 'Model';
  /* Shopify returns at most 100 values per filter. When the Model filter hits that cap (brand-wide
     collections such as all Samsung parts, or All Parts) the list is silently incomplete, so it is hidden;
     shoppers narrow down with the series collections (iPhone, Galaxy S, Galaxy A...) where it is complete. */
  var MODEL_VALUE_CAP = 100;
  /* Trade customers see wholesale prices from the wholesale app, but the Price filter works on list
     prices, so its ranges would not match what they see. The Price filter is hidden in this theme. */
  var HIDE_PRICE_FILTER = true;
  /* Shopify has no collection sort that puts sold-out products last, so on collection and search grids
     the sold-out cards are moved to the end of the current page (keeping their relative order).
     This works per page (96 products per page on collections). */
  var SOLD_OUT_RE = /sold\s*out|\u552e\u7f44|\u5df2\u552e\u5b8c/i;
  /* Collection links in the menu, footer, breadcrumbs and homepage cards open with the "In stock" filter on
     (Cat, Sep 29). The links keep their clean URLs (better for SEO); the filter is added when clicked.
     Links inside the filter panel, active-filter chips, pagination and search are left alone, so shoppers can
     still untick the filter to see sold-out parts. Ctrl/Cmd/middle-click open the plain collection. */
  var IN_STOCK_PARAM = 'filter.v.availability=1';
  var COLLECTION_PATH = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^\/]+\/?$/i;

  function slug(s){ return s.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  function makePill(grade){
    var s = document.createElement('span');
    s.className = 'ss-pill ss-pill--grade ss-grade ss-grade--' + slug(grade);
    s.textContent = grade;
    return s;
  }

  function runGrades(){
    var nodes = document.querySelectorAll('.card__heading > a, .product__title > h1');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-ss-grade')) continue;
      el.setAttribute('data-ss-grade', '1');
      var t = el.textContent;
      var m = t.match(RE);
      if (!m) continue;
      el.textContent = t.replace(RE, '');
      el.parentNode.insertBefore(makePill(m[1].trim()), el);
    }
  }

  function isSoldOut(item){
    var badges = item.querySelectorAll('.card__badge .badge, .badge');
    for (var i = 0; i < badges.length; i++) {
      if (SOLD_OUT_RE.test(badges[i].textContent)) return true;
    }
    return false;
  }

  function sinkSoldOut(){
    var grids = document.querySelectorAll('#product-grid');
    for (var g = 0; g < grids.length; g++) {
      var grid = grids[g];
      var items = [];
      for (var c = 0; c < grid.children.length; c++) {
        if (grid.children[c].tagName === 'LI') items.push(grid.children[c]);
      }
      var sold = [], seenSold = false, needsMove = false;
      for (var i = 0; i < items.length; i++) {
        var s = isSoldOut(items[i]);
        if (s) { sold.push(items[i]); seenSold = true; }
        else if (seenSold) needsMove = true;
      }
      if (!needsMove) continue;
      for (var k = 0; k < sold.length; k++) grid.appendChild(sold[k]);
    }
  }

  function onCollectionLinkClick(e){
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.target === '_blank') return;
    if (a.closest('facet-filters-form, .facets, .facets-container, .active-facets, facet-remove, .pagination, .pagination-wrapper, .ss-search, .mobile-facets')) return;
    var u;
    try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
    if (u.origin !== location.origin || u.search || !COLLECTION_PATH.test(u.pathname)) return;
    e.preventDefault();
    u.search = '?' + IN_STOCK_PARAM;
    location.href = u.toString();
  }

  function relabel(root, exactOnly){
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      var v = n.nodeValue;
      if (v.indexOf(TAG_FILTER_FROM) < 0) continue;
      if (exactOnly && v.trim() !== TAG_FILTER_FROM) continue;
      n.nodeValue = v.replace(TAG_FILTER_FROM, TAG_FILTER_TO);
    }
    var labelled = root.querySelectorAll('[aria-label]');
    for (var k = 0; k < labelled.length; k++) {
      var a = labelled[k].getAttribute('aria-label');
      if (a && a.indexOf(TAG_FILTER_FROM) > -1) labelled[k].setAttribute('aria-label', a.replace(TAG_FILTER_FROM, TAG_FILTER_TO));
    }
  }

  function hide(el){ if (el.style.display !== 'none') el.style.display = 'none'; }

  function runFilterLabels(){
    var groups = document.querySelectorAll('details');
    for (var i = 0; i < groups.length; i++) {
      var d = groups[i];
      var tagInputs = d.querySelectorAll('input[name="filter.p.tag"]');
      if (tagInputs.length) {
        /* Skip wrapper <details> that hold every filter (mobile drawer root) */
        var isGroup = !d.querySelector('input[name^="filter.v.availability"], input[name^="filter.v.price"], input[name*="custom.grade"]');
        relabel(d, true);
        if (isGroup) {
          var vals = {};
          for (var j = 0; j < tagInputs.length; j++) vals[tagInputs[j].value] = 1;
          var active = d.querySelector('input[name="filter.p.tag"]:checked');
          if (Object.keys(vals).length >= MODEL_VALUE_CAP && !active) hide(d);
        }
      }
      if (HIDE_PRICE_FILTER && d.querySelector('input[name^="filter.v.price"]') &&
          !d.querySelector('input[name="filter.p.tag"], input[name^="filter.v.availability"], input[name*="custom.grade"]')) {
        hide(d);
      }
    }
    /* Active-filter chips: only links that remove a tag filter */
    var chips = document.querySelectorAll('a[href*="filter.p.tag"], facet-remove');
    for (var c = 0; c < chips.length; c++) relabel(chips[c], false);
  }

  function initSearch(root){
    var input = root.querySelector('.ss-search__input');
    var box = root.querySelector('.ss-search__results');
    if (!input || !box) return;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var timer, ctrl, items = [], active = -1;

    function close(){
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }
    function setActive(i){
      active = i;
      for (var k = 0; k < items.length; k++) items[k].setAttribute('aria-selected', k === i ? 'true' : 'false');
      if (items[i]) input.setAttribute('aria-activedescendant', items[i].id);
      else input.removeAttribute('aria-activedescendant');
    }
    function render(products, q){
      box.innerHTML = '';
      items = [];
      if (!products.length) {
        var e = document.createElement('p');
        e.className = 'ss-search__empty';
        e.textContent = 'No parts found for "' + q + '"';
        box.appendChild(e);
      }
      products.forEach(function(p, i){
        var a = document.createElement('a');
        a.href = p.url;
        a.className = 'ss-search__item';
        a.id = root.id + '-opt-' + i;
        a.setAttribute('role', 'option');
        var img = p.image || (p.featured_image && p.featured_image.url);
        if (img) {
          var im = document.createElement('img');
          im.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=96';
          im.alt = '';
          im.width = 48; im.height = 48;
          im.loading = 'lazy';
          a.appendChild(im);
        }
        var t = document.createElement('span');
        var title = p.title || '';
        var m = title.match(RE);
        if (m) { t.appendChild(makePill(m[1].trim())); t.appendChild(document.createTextNode(title.replace(RE, ''))); }
        else { t.textContent = title; }
        a.appendChild(t);
        box.appendChild(a);
        items.push(a);
      });
      var all = document.createElement('a');
      all.className = 'ss-search__all';
      all.href = base + 'search?type=product&q=' + encodeURIComponent(q);
      all.textContent = 'See all results for "' + q + '"';
      box.appendChild(all);
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
    }

    input.addEventListener('input', function(){
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function(){
        if (ctrl) ctrl.abort();
        ctrl = ('AbortController' in window) ? new AbortController() : null;
        var url = base + 'search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, ctrl ? { signal: ctrl.signal } : {})
          .then(function(r){ return r.json(); })
          .then(function(d){ render((d.resources && d.resources.results && d.resources.results.products) || [], q); })
          .catch(function(){});
      }, 200);
    });
    input.addEventListener('keydown', function(e){
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(active + 1, items.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(active - 1, -1)); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); window.location.href = items[active].href; }
      else if (e.key === 'Escape') { close(); }
    });
    document.addEventListener('click', function(e){ if (!root.contains(e.target)) close(); });
  }

  function runAll(){ runGrades(); runFilterLabels(); sinkSoldOut(); }

  function init(){
    runAll();
    var roots = document.querySelectorAll('.ss-search');
    for (var i = 0; i < roots.length; i++) initSearch(roots[i]);
    var timer;
    new MutationObserver(function(){
      clearTimeout(timer);
      timer = setTimeout(runAll, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
